import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
const useAuthRedirect = () => {
  const navigate = useNavigate();
  const { userInfo, accessToken } = useSelector((state) => state.auth);
  useEffect(() => {
    const isTokenValid = (token) => {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);
        return decoded.exp && decoded.exp > currentTime + 10; // 10s buffer
      } catch (e) {
        return false;
      }
    };
    if (accessToken && userInfo && isTokenValid(accessToken)) {
      navigate("/dashboard", { replace: true });
    }
  }, [userInfo, accessToken, navigate]);
};
export default useAuthRedirect;